import Icon from "@3gaam/shared/components/general/icon";
import React from "react";
import BootstrapModal, { ModalProps } from "react-bootstrap/Modal";

type Props = {
  setShow: (val: boolean) => void;
  showState: boolean;
  fullscreen?: string;
  className?: string;
  bodyClassName?: string;
  size?: ModalProps["size"];
  noCloseBtn?: boolean;
  backdrop?: boolean | "static";
  bsPrefix?: string | undefined;
  children: React.ReactNode;
  animation?: boolean;
};
const Modal = ({
  setShow,
  showState,
  className,
  bodyClassName,
  size,
  noCloseBtn,
  backdrop,
  children,
  animation,
  bsPrefix,
  fullscreen
}: Props) => {
  return (
    <BootstrapModal
      show={showState}
      onHide={() => {
        setShow(false);
      }}
      dialogClassName={className}
      size={size}
      backdrop={backdrop}
      bsPrefix={bsPrefix}
      fullscreen={fullscreen}
      centered
      animation={animation !== undefined ? animation : true}
      onExited={() => setShow(false)}
    >
      <BootstrapModal.Body className={bodyClassName || "p-0"}>
        {!noCloseBtn && (
          <div className="close-btn" onClick={() => setShow(false)}>
            <Icon name="FA_R-xmark" />
          </div>
        )}
        {children}
      </BootstrapModal.Body>
    </BootstrapModal>
  );
};

export default React.memo(Modal);
